/* @flow */

import Events from 'minivents';

window.App.eventManager = new Events();
